module.exports = __webpack_public_path__ + "ah.no2.2ed545bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ah.no2.jpg
// module id = X8vJ
// module chunks = 0